// Module
var code = "<md-button class=\"md-icon-button\" ui-sref=\"{{::$ctrl.destination || $ctrl.resource.$getRoute('add')}}({ duplicateResource: $ctrl.resource })\" tmr-if-access=\"$ctrl.destination || $ctrl.resource.$getRoute('add')\"> <md-tooltip>{{'RESOURCEACTION.DUPLICATE' | translate}}</md-tooltip> <md-icon class=\"o-add-layer-1\"></md-icon> </md-button> ";
// Exports
var _module_exports =code;;
var path = 'components/resourceActions/resourceActionDuplicate/resourceActionDuplicate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;